export default class RelatedState {}
